<div class="content-wrapper">
	<div class="membership-banner text-center">

		<div class="banner-object">
			<img class="d-md-none" src="assets/images/mob-banner-object.png" alt="mylifewell">
			<img class="d-none d-md-block" src="assets/images/banner-object.jpg" alt="MyLifeWell">
		</div>
		<div class="container container2">
			<div class="row align-items-md-center FirstSection">
				<div class="col-md-6">
					<div class="banner-details text-md-left ">
						<!-- text-uppercase -->
						<h1 class="banner-head textTransformNone">
							Get results
							<br />
							with the first
							<br />
							<span class="colorLightBlue">
								all-in-one
							</span>
							health &
							<br />
							wellness platform.
						</h1>
						<p class="banner-desc">
							The best
							<span class="colorLightBlue underLine AnimationClass"
								[class.is-visible]="(textMatched == i?.id) ? true : false" *ngFor="let i of textInfo">
								{{ i?.value }}
							</span>
							<!-- <span class="colorLightBlue underLine AnimationClass is-visible">
                                {{ textInfo[textMatched] }}
                            </span> -->
							<!-- All for less than the cost of a regular gym membership. All in the palm of your hand. -->
							<span class="inlineCss">
								in the palm of your hand for less than a cup of coffee a day.
							</span>
						</p>
						<!-- <a class="btn btn-trail d-none d-md-inline-block cta-hero"
							[href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'">
							GET 7-DAYS FREE
						</a> -->
						<a class="btn btn-trail d-none d-md-inline-block cta-hero"
							[href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'">
							GET 7-DAYS FREE
						</a>
						<h6 *ngIf="" class="colorLightBlue fontWeight600" style="padding: 10px 15px;">
							offer ends Oct 15, 2021.
						</h6>
					</div>
				</div>
				<div class="col-md-6">
					<figure class="banner-devices">
						<img src="assets/images/membership/banner-devices-55-cents.png" alt="mylifewell">
					</figure>
					<!-- <video class="videoTag1" autoplay>
                        <source src="assets/images/imagesForVariationFitness/mylifewell-app-screenshots.mp4" type="video/mp4">
                    </video>                       -->
					<a class="btn btn-trail d-md-none cta-hero" [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'">
						Activate 7 Day Free Membership
					</a>
				</div>
			</div>
			<a class="exp-link" style="text-align: -webkit-center;" (click)="goTototalHealth()">
				<span class="arrow d-flex align-items-center justify-content-center cursorHand">
					<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-down" role="img"
						xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"
						class="svg-inline--fa fa-long-arrow-down fa-w-8 fa-2x">
						<path fill="#a5a5a5"
							d="M252.485 343.03l-7.07-7.071c-4.686-4.686-12.284-4.686-16.971 0L145 419.887V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v375.887l-83.444-83.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l116 116.485c4.686 4.686 12.284 4.686 16.971 0l116-116.485c4.686-4.686 4.686-12.284-.001-16.97z"
							class=""></path>
					</svg>
				</span>
				<span class="txt text-uppercase">
					Create A Life You Love
				</span>
			</a>
		</div>
	</div>
	<div class="container container2">
		<div class="row">
			<div class="col-md-12">
				<div class="d-flex appLinksButton">
					<a href="https://play.google.com/store/apps/details?id=digifit.android.virtuagym.pro.mylifewell&hl=en&gl=US"
						target="_blank">
						<img src="../../assets/images/activation-b2c/download-googe-play.png" alt="Mylifewell">
					</a>
					<a href="https://apps.apple.com/app/id1558197173" target="_blank">
						<img src="../../assets/images/activation-b2c/download-appstore-ios.png" alt="Mylifewell">
					</a>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="content-wrapper">
	<div class="membership-banner text-center">

		<div class="container container2" id="totalHealth">
			<div class="row">
				<div class="col-md-12 text-center secondSectionBefore">
					<h1>
						Total Health.
					</h1>
					<h5>
						Fitness, Nutrition, Yoga And Mindset Combined.
					</h5>
				</div>
			</div>
			<div class="row healthSection">
				<div class="col-md-7 secondSection">
					<h1>
						<!-- Get results, fast. -->
						Get moving.
					</h1>
					<p class="makeHead">
						<!-- The Biggest Fitness Library -->
						Burn all the calories and never get bored with the largest fitness library.
					</p>
					<p>
						2000+ instructor-led on-demand classes.
					</p>
					<p>
						5000+ exercise movements.
					</p>
					<p>
						12+ categories including core, target areas, strength, yoga and active aging.
					</p>
					<!-- <p>
						Weekly live classes.
					</p> -->
				</div>
				<div class="col-md-5 secondSectionSecondCol">
					<!-- <ngx-slick-carousel class="carousel"  [config]="slideConfig" >
                <div class="slide-item" ngxSlickItem *ngFor="let i of [1,2,3,4,5,6,7,8,9]"> -->
					<!-- <figure class="d-md-none">
						<img src="../../assets/images/imagesForVariationFitness/cardio.png">
					</figure> -->
				
					<video loop muted autoplay playsinline oncanplay="this.play()" onloadedmetadata="this.muted = true">
						<source src="assets/images/imagesForVariationFitness/Get moving.mp4" type="video/mp4">
				</video>
				

					<!-- <video class="videoTag2 d-none d-md-inline-block" autoplay">
						<source src="assets/images/imagesForVariationFitness/Get moving.mp4" type="video/mp4">
					</video> -->
					<!-- </div>
            </ngx-slick-carousel> -->
				</div>
			</div>
		</div>
	</div>
</div>
<div class="mainDivOfAfterSecondSection">
	<section class="afterSecondSection">
		<div class="container container2">
			<div class="row">
				<div class="col-md-6 marginTop10">
					<ngx-slick-carousel class="carousel" [config]="slideConfig">
						<div class="slide-item" ngxSlickItem *ngFor="let img of screenshotCarousel">
							<figure>
								<img src={{img}}>
							</figure>
						</div>
					</ngx-slick-carousel>
				</div>
				<div class="col-md-6">
					<section class="resultSec">
						<h2 class="colorWhite">
							Get results.
						</h2>
						<h5 class="colorWhite">
							Your total wellness toolbox.
						</h5>
						<p class="colorWhite">
							Built-in nutrition tracker, barcode scanner and meal planner.
						</p>
						<p class="colorWhite">
							Mindfulness and meditation to manage stress, calm and empower.
						</p>
						<p class="colorWhite">
							In-depth programs like Yoga Foundations, 7 Days of Core Strength, and Craving Kicker.
						</p>
						<p class="colorWhite">
							Integrated calorie tracker across all activities.
						</p>
					</section>
					<div class="motivatedSec">
						<h2 class="secondH2 no-trans">
							Get motivated.
						</h2>
						<h5 class="no-trans">
							Wellness made fun.
						</h5>
						<p>
							Fun challenges with exciting prize.
						</p>
						<p>
							Rewarding Loyality and Referral program.
						</p>
						<p>
							Groups and communties led by expert coaches to support and motivate.
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
<section class="thirdSecNew">
	<div class="container container2">
		<div class="row">
			<div class="col-md-8">
				<h2>
					Get connected.
				</h2>
				<p>
					Connect your wearable, Apple Health or Google Fit.
				</p>
				<p>
					Stream to your Smart TV-using Apple Play or Chromecast.
				</p>
			</div>
			<div class="col-md-4">
				<figure>
					<img src="../../assets/images/imagesForVariationFitness/wearable-watch-neo-health-go.png">
				</figure>
			</div>
		</div>
	
	</div>
</section>

<!-- <section>
	<div class="container container2">
			<div class="d-flex justify-content-center CTA-BTN">
				<a class="btn btn-trail cta-hero"
				[href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'">
				GET 7-DAYS FREE
				</a>
			</div>
		</div>
</section> -->


<section *ngIf="" class="thirdSectionTag">
	<div class="container container2">
		<div class="row">
			<div class="col-md-6 thirdSection">
				<figure class="imgOne">
					<img src="../../assets/images/imagesForVariationFitness/coach-suse.png" alt="MyLifeWell">
				</figure>
				<figure class="imgTwo">
					<img src="../../assets/images/imagesForVariationFitness/coach-nathan.png" alt="MyLifeWell">
				</figure>
				<figure class="imgThree">
					<img src="../../assets/images/imagesForVariationFitness/coach-chelsie.png" alt="MyLifeWell">
					<div class="imgThreeDiv">
						Chelsie <br />
						Nutrition Coach <br />
						Bsc, ICF
					</div>
				</figure>
			</div>
			<div class="col-md-6 thirdSectionSecondCol">
				<h1>
					Get results that last.
				</h1>
				<h4>
					Transformative Personal Training
				</h4>
				<p>
					Globally-renowned personal trainers and wellness coaches .
				</p>
				<p>
					Custom workout and nutrition plans, tailored to your goals.
				</p>
				<p>
					1:1 training in the palm of your hand.
				</p>
			</div>
		</div>
	</div>
</section>
<section class="connectWithExpert">
	<div class="container container2">
		<div class="row">
			<h5 class="text-center">
				Connect with experts who help guide and motivate.
			</h5>
		</div>
		<div class="row">
			<div class="col-md-2 imgOfCoach text-center" *ngFor="let i of expertsArr">
				<figure>
					<img [src]="i?.img" alt="MyLifeWell">
				</figure>
				<p class="firstPara">
					{{ i?.name }}
				</p>
				<p class="secondPara">
					{{ i?.desc }}
				</p>
			</div>
		</div>
	</div>
</section>
<section class="getMoreValue">
	<div class="container container2">
		<div class="row">
			<div class="col-md-6">
				<h2>
					Get more value.
				</h2>
				<h5>
					Save up to $50 per month
				</h5>
				<p>
					Say goodbye to multiple apps and subscriptions.
				</p>
				<p>
					The most popular apps, combined.
				</p>
				<p>
					Maximize your results by tracking your progress in one place.
				</p>
				<h6>
					<span class="line-height">
						<a [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'">Save now with MyLifeWell</a>
					</span>
				</h6>
			</div>
			<div class="col-md-6">
				<figure>
					<img src="../../assets/images/imagesForVariationFitness/more-value-2.png">
				</figure>
			</div>
		</div>
	</div>
</section>

<section *ngIf="" class="fifthSectionTag">
	<div class="container container2">
		<div class="row fifthSection">
			<div class="col-md-12 text-center">
				<h2>
					Get results that matter
				</h2>
			</div>
			<div class="col-md-6">
				<h4>
					Total Health
				</h4>
				<p>
					Maximize and combine your efforts in one place.
				</p>
				<p>
					Built-in nutrition tracker and barcode
					scanner.
				</p>
				<p>
					Workouts for your body and mind.
				</p>
				<p>
					Original longer-form content so you
					can master your wellbeing
				</p>
				<figure class="band">
					<img src="../../assets/images/imagesForVariationFitness/wearable-watch-neo-health-go.png" alt="MyLifeWell">
				</figure>
			</div>
			<div class="col-md-6">
				<figure class="mobileImg">
					<img src="../../assets/images/imagesForVariationFitness/iphone-mylifewell-food-app.png" alt="MyLifeWell">
				</figure>
			</div>
		</div>
	</div>
</section>
<div *ngIf="" class="container container2">
	<div class="row sixthSection">
		<div class="col-md-5 m-auto">
			<figure>
				<img src="../../assets/images/imagesForVariationFitness/google-play-store.png" alt="MyLifeWell">
				<img src="../../assets/images/imagesForVariationFitness/app-store-ios.png" alt="MyLifeWell">
			</figure>
		</div>
		<div class="col-md-7">
			<h2>
				Customized to Your Goals
			</h2>
			<p>
				Track progress, whatever your goal.
			</p>
			<p>
				Lose weight tone & sculpt, get strong, or just stay fit.
			</p>
			<p>
				Connect your wearable, Apple
				Health or Google Fit
			</p>
		</div>
	</div>
</div>
<section class="seventhSectionTag">
	<div class="container container2">
		<div class="row seventhSection">
			<ngx-slick-carousel class="carousel" [config]="reviewslideConfig">
				<div class="slide-item" ngxSlickItem *ngFor="let obj of reviewCarousel;">
					<div class="row">
						<div class="col-md-5" *ngIf="obj.reviewType=='user'">
							<figure>
								<img class="img1" src="../../assets/images/imagesForVariationFitness/beth_1.png" alt="MyLifeWell">
								<img class="starRating" src="../../assets/images/imagesForVariationFitness/5 stars.png"
									alt="MyLifeWell">
							</figure>
						</div>
						<div [ngClass]="obj.reviewType=='user'?'col-md-7':'col-md-12'">
							<h2 *ngIf="obj.reviewType=='user'">
								Get to know Beth.
							</h2>
							<h2 *ngIf="obj.reviewType!='user'" class="text-center line-height">
								Reviews
							</h2>
							<p class="inMobileTextJustify textForRachel">
								{{obj.review}}
							</p>
							<div class="applogo text-center">
								<a >
									<img *ngIf="obj.device=='Android Reviews'"
										src="../../assets/images/activation-b2c/download-googe-play.png" alt="Mylifewell">
								</a>
								<a >
									<img *ngIf="obj.device=='iOS Reviews'"
										src="../../assets/images/activation-b2c/download-appstore-ios.png" alt="Mylifewell">
								</a>
							</div>
							<p *ngIf="obj.reviewType=='user'" class="text-center">
								<span class="underLine">
									<!-- <a href="https://play.google.com/store/apps/details?id=digifit.android.virtuagym.pro.mylifewell&hl=en&gl=US"> -->
										See what others are saying about MyLifeWell
									<!-- </a> -->
								</span>
							</p>
						</div>
					</div>

				</div>
			</ngx-slick-carousel>
		</div>
	</div>
</section>
<div class="faq-section asSeenIn">
	<div class="container container2">
		<div class="main-heading">
			<h2 class="main-title text-capitalize">
				AS SEEN IN
			</h2>
		</div>
		<div class="row fourthSection">
			<div class="col-md-4 m-auto">
				<figure>
					<img src="../../assets/images/imagesForVariationFitness/as-seen-in-yahoo-finance.png" alt="MyLifeWell">
				</figure>
			</div>
			<div class="col-md-4 m-auto">
				<figure>
					<img src="../../assets/images/imagesForVariationFitness/as-seen-in-business-wire.png" alt="MyLifeWell">
				</figure>
			</div>
			<div class="col-md-4 m-auto">
				<figure>
					<img src="../../assets/images/imagesForVariationFitness/as-seen-in-authority-magazine.png" alt="MyLifeWell">
				</figure>
			</div>
		</div>
	</div>
</div>
<div class="container">
	<div class="row eightSection">
		<div class="col-md-12 text-center">
			<h2>
				Get more with MyLifeWell.
			</h2>
		</div>
		<div class="col-md-4 colFour">
			<figure>
				<img src="../../assets/images/imagesForVariationFitness/icon-TravelWell.png">
			</figure>
			<h5>
				Wellness Travel
			</h5>
			<p class="line-height">
				Discounted wellness travel at top destinations around the world.
			</p>
		</div>
		<div class="col-md-4 colFour">
			<figure>
				<img src="../../assets/images/imagesForVariationFitness/icon-Shop_well.png">
			</figure>
			<h5>
				Wellness Products
			</h5>
			<p class="line-height">
				Discounted wellness products to support your healthy lifestyle.
			</p>
		</div>
		<div class="col-md-4 colFour">
			<figure>
				<img src="../../assets/images/imagesForVariationFitness/icon-mindvibe.png">
			</figure>
			<h5>
				Transformative Personal Coaching
			</h5>
			<p class="line-height">
				Globally-renowned wellness coaches and trainers.
			</p>
		</div>
	</div>
</div>
<section style="background-color:#f44575;">
	<div class="container container2">
		<div class="row ninthSection">
			<div class="col-md-12">
				<h2>
					Get started today for zero dollars
				</h2>
				<div class="text-center pb-2">
					<button>
						<a [href]="hostedUrl+'register/607e5455a745132f5c3cb9b0-discount'">GET 7 DAYS FREE</a>
					</button>
				</div>
				<h5>
					<!-- Get started with two weeks of unlimited wellness, FREE. Cancel anytime. -->
					$16.90/month after the free trial. Cancel anytime.
				</h5>
			</div>
		</div>
	</div>
</section>
<div class="faq-section">
	<div class="container">
		<div class="main-heading">
			<h2 class="main-title text-capitalize">Frequently Asked Questions</h2>
		</div>
		<ul class="faq-list">
			<li class="accordian" (click)="accordianChange(0)">
				<h3>Q. How do I activate the free 7-day membership?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						To activate your free trial, simply signup and complete your registration details. Once submitted, you'll
						get an email from us with your app download and login details so you can start enjoying three months of
						unlimited access.
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(1)">
				<h3>Q. How Is MyLifeWell Different Than Other Wellness Apps?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						Comprehensive: You probably have to subscribe to 3-4 different apps to find the right on-demand classes,
						guided meditations, social support groups, personal training, nutrition and caloric tracking. MyLifeWell
						brings everything together in one seamless app making it easier to adopt a wellness lifestyle in your
						day-to-day life.
						<br>
						<br>
						Variety: The MyLifeWell app offers 2000+ Yoga, HIIT, Barre, Kettlebell, Dance, Kick Boxing, Meditation,
						Cycling, Breathwork, Pilates and even Ballet bootcamp classes to choose from. Try something different each
						day and who knows, you may find a new passion! In addition, we offer 5000+ 3D animated videos for creating
						custom at-home and gym workouts.
						<br>
						<br>
						Quality: We make sure that you get only the best content across all categories.
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(2)">
				<h3>Q. Do I Need A Lot Of Equipment To Work Out?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						Not at all. We have a lot of classes that do not require any equipment. If you want to use an equipment then
						you can quickly filter the classes by different equipment options such as dumbell, kettlebell, resistance
						band and so on.
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(3)">
				<h3>Q. Do I have to be experienced to do the classes?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						Not at all. We have classes whether it’s your first time or you work out all the time. Start with where
						you’re at and build up from there, you’ll be surprised at how quickly you learn and grow.
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(4)">
				<h3>Q. I don’t have a lot of time, how long are the classes?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						We have classes ranging from 5 min to hour long fitness classes. So, whether you are looking for a quick 10
						min office workout or a 60 min full body workout, we have got you covered.
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(5)">
				<h3>Q. Do you have a rewards program?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						We will soon be launching a rewards program which means that not only will you be leading a healthier
						lifestyle but you will also be rewarded for it. Is there anything better?!!
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(6)">
				<h3>Q.If the first 7-day is free, why do I have to enter a credit card?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						When you sign up for your free 7-days of unlimited access, you are enrolling in a MyLifeWell subscription
						product. Your card will not be charged during the free month's membership period. At the end of the free
						membership period, the card will be charged per your subscription plan. You can cancel your membership at
						any time before or after the end of the free membership period.
					</p>
				</div>
			</li>
			<li class="accordian" (click)="accordianChange(7)">
				<h3>Q. What is the regular monthly cost after the 7-days Free Trial?
					<span class="plus-wrap"></span>
				</h3>
				<div class="faq-content">
					<p>
						We have two subscription plans: the Monthly Plan is $19.90/month and the Quarterly Plan is $14.90/month paid
						every three months.
					</p>
				</div>
			</li>
		</ul>
	</div>
</div>
<app-subscribe-newsletter></app-subscribe-newsletter>
<!-- <app-modal-pop-up [responseMessage]="popUpMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
</app-modal-pop-up> -->